import { render, staticRenderFns } from "./OperateLog.vue?vue&type=template&id=5bf3cb76&scoped=true&"
import script from "./OperateLog.vue?vue&type=script&lang=js&"
export * from "./OperateLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3cb76",
  null
  
)

export default component.exports